import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconShareSvg } from "./IconShareSvg.mjs";
const IconShare = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconShareSvg, ...iconProps });
};
export {
  IconShare
};
